import {IonContent, IonPage} from "@ionic/react";
import React from "react";

const UserManagerPage: React.FC<any> = ({children, page}: any) => {

    return (
        <IonPage>
            <IonContent fullscreen>

                <table style={{width: "100%", height: "90%"}}>
                    <tbody>
                        <tr style={{height: "60px"}}>
                            <td colSpan={2} style={{display: "table-cell", width: "100%", height: "60px"}}>
                                <h3 style={{textTransform: "capitalize", marginLeft: '20px'}}>{page.replaceAll("-", " ")}</h3>
                            </td>
                        </tr>
                        <tr style={{height: "100%"}}>
                            <td style={{verticalAlign: "top", padding:'0px', width: '100%', minWidth: '300px',
                                whiteSpace: 'nowrap',}}>
                                <div style={{padding:'0px'}}>
                                    {children}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </IonContent>
        </IonPage>
    );
}
export default UserManagerPage;